import { Selector } from '../../FormElements/Selector';
import SubmitButton from '../../FormElements/SubmitButton';
import * as React from 'react';
import { useBankAccountMoveForm } from './useBankAccountMoveForm';

export const BankAccountMoveForm = () => {
  const { onClose, onSubmit, isLoading, setOptions, companies } = useBankAccountMoveForm();
  return (
    <form onSubmit={onSubmit}>
      <div className="row ">
        <label htmlFor="integrator" className="form-label fs-5">
          Választható cégek:
        </label>
        <Selector
          ariaLabel={'cégek'}
          id="company"
          options={companies}
          onChange={setOptions}
          isMulti={false}
          placeholder="Válasszon céget!"
          defaultValue={undefined}
        />
        <div className=" mt-lg-5 d-flex justify-content-around">
          <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal">
            Mégse
          </button>
          <SubmitButton
            text="Áthelyezés"
            className={'btn btn-primary'}
            inProgress={isLoading}
            disabled={isLoading}
            dataTestId={'generateTokenBtn'}
          />
        </div>
      </div>
    </form>
  );
};
